module.exports = __webpack_public_path__ + "img/imgAndFile.828c4aa6.png";